// extracted by mini-css-extract-plugin
export default {"container":"Xq-z","brandName":"Yq-z","productName":"Zq-z","productNamePdpEnhancements":"_q-z","breakLongProductName":"ar-z"};